import React, { useState, useRef } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import './modal.css';

const ModalForm = ({ isOpen, toggleModal }) => {

    const [formData, setFormData] = useState({
        fullname: "",
        email: "",
        mobile: "",
        message: "",
    });

    const [submitted, setSubmitted] = useState(false); // State to track submission
    const formRef = useRef(null);

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "fullname") {
            // Allow only alphabets and spaces
            if (/^[A-Za-z\s]*$/.test(value) || value === "") {
                setFormData({ ...formData, [name]: value });
            }
        } else if (name === "mobile") {
            // Allow only positive numbers and restrict to 10 characters
            if (/^\d*$/.test(value) && value.length <= 10) {
                setFormData({ ...formData, [name]: value });
            }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        const timestamp = new Date().toISOString();

        const formDataObj = new FormData(formRef.current);
        formDataObj.append("timestamp", timestamp);


        fetch("https://script.google.com/macros/s/AKfycbzkHNf5ex37YcbMS2BVCuykELtKM_C9vr2PqyeQ5HWfWSv3w8jBBIKPW9_wjo-PRus/exec", {
            method: "POST",
            body: formDataObj,
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error("Network response was not ok");
                }
                return res.json();
            })
            .then((data) => {
                console.log(data);

                formRef.current.reset(); // Clear form fields
                setFormData({
                    fullname: "",
                    email: "",
                    mobile: "",
                    message: "",
                });

                // Show thank-you message
                setSubmitted(true);

                setTimeout(() => setSubmitted(false), 5000);
            })
            .catch((err) => {
                console.error("There was a problem with the fetch operation:", err);
                alert("Submission failed. Please try again.");
            });
    };

    return (
        <Modal show={isOpen} onHide={toggleModal} centered dialogClassName="custom-modal">
            <div
                className="modal-bg"
            
            >
                <Modal.Header closeButton className="custom-modal-header" >
                    <div className="text-center model">
                        <Modal.Title className="centered-title p-2">
                           <h1>Balloon Decoration</h1>
                        </Modal.Title>

                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form ref={formRef} onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="formName">
                            <Form.Label className="form-label">Full Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter Name"
                                name="fullname"
                                value={formData.fullname}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formContactDetails">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <Form.Label>Email Id</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="Enter email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <Form.Label>Mobile No</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Number"
                                        name="mobile"
                                        value={formData.mobile}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formMessage">
                            <Form.Label className="form-label">Message</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <div className="con-btn">
                            <Button variant="success" type="submit" className="ms-3 btn btn-warning">
                                SEND MESSAGE
                            </Button>
                        </div>

                        {/* Thank-you message */}
                        {submitted && (
                            <Form.Group className="mt-3">
                                <Form.Control
                                    type="text"
                                    value="Thank you for your submission!"
                                    readOnly
                                    style={{
                                        textAlign: "center",
                                        backgroundColor: "#25d366",
                                        fontWeight: "bold",
                                    }}
                                />
                            </Form.Group>
                        )}
                    </Form>
                </Modal.Body>
            </div>
        </Modal>
    );
};

export default ModalForm;
